import { Component, OnInit, ViewChild, ElementRef, Input } from "@angular/core";
import {
  IFilterComponent,
  SearchFilter,
} from "../../../infrastructure/iFilter-component";
import { FormGroup, FormBuilder } from "@angular/forms";
import { FilterService } from "../../../services/filter.service";
import { AuthService } from "../../../services/auth.service";
import { FilterRecordService } from "../../../services/filter-record.service";
import { StudyReportService } from "../../../services/study-report/study-report.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-study-report-template-filter",
  templateUrl: "./study-report-template-filter.component.html",
})
export class StudyReportTemplateFilterComponent
  implements IFilterComponent, OnInit
{
  form: FormGroup;
  @ViewChild("formElement", { static: false }) formElement: ElementRef;
  editorId: number;

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private studyReportService: StudyReportService,
    private filterRecordService: FilterRecordService,
  ) {
    const date = new Date();

    this.form = this.formBuilder.group({
      Name: [""],
      Deleted: [false]
    });
  }

  get f() {
    return this.form.controls;
  }

  async saveFilters() {
    this.filterRecordService.saveFilters(
      "StudyReportTemplateFilterComponent",
      this.form,
    );
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters(
      "StudyReportTemplateFilterComponent",
      this.form,
    );
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(
      this.form,
      requiredTags,
    );
  }

  async search(): Promise<any> {


    this.editorId = Number(this.route.snapshot.params["editorId"]);


    return await this.studyReportService.getStudyReportTemplateFiltersByName(
      this.form.controls.Name.value,
      <boolean>(
        (this.form.controls.Deleted.value
          ? this.form.controls.Deleted.value
          : false)
      ), this.editorId
    );
  }

  async ngOnInit() {

  }
}
